module.exports = __webpack_public_path__ + "static/img/banner.ed3f87b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner.jpg
// module id = oxzm
// module chunks = 1